import React from 'react';
import _ from 'lodash';

import Master from '../../Components/Master';
import Loader from '../../Components/Loader';
import ButtonGroup from '../../Components/ButtonGroup';

import MitarbeiterTable from './mitarbeiter';
import StundenTable from './stunden';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import { doPost, doLoad, doPut, select, doDelete, apiUrlOpen } from '../../Redux/Actions'
import store from '../../Redux';

import AddIcon from '@material-ui/icons/Add';
import PrintIcon from '@material-ui/icons/Print';
import PdfIcon from '@material-ui/icons/PictureAsPdf';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

import DatePickerContainer from '../../Components/DatePickerContainer';
import LinearProgress from '@material-ui/core/LinearProgress';

import { ColumnHeaderCell, EditableCell, Cell, Column, Table } from "@blueprintjs/table";

import moment from 'moment'
import 'moment/locale/de'
moment.locale("de");

const ENDPOINT = "mitarbeiter"

const styles = theme => ({

})

const columns = [
    "Name"
];


class ListObject extends Master {

    state = {
        ...this.state,
        isLoading: true,
        dialogOpen: false,
        newEntry: {},
        route: "/" + ENDPOINT,
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),

        currentMonth: moment().toDate(),
        tmpMonth: moment(),

        daysArray: [],
        dateArray: [],

        selectedUser: undefined,
    }

    componentDidMount() {

        document.title = "Monatsübersicht"

        this.calcDays()
        this.unsubscribe = store.subscribe(() => {
                var generic = select(store.getState(), "dienstSingle")
                if(generic) {
                    var changed = false
                    this.props.dienst.data.forEach((item, k) => {
                        if(generic.data.id === undefined || item.id === undefined) {
                            return
                        }
                        if(item.id === generic.data.id) {
                            this.props.dienst.data[k] = generic.data
                            changed = true
                        }
                    })
                    if(changed) {
                        this.setState({})
                    }
                }
                var generic = select(store.getState(), ENDPOINT)
                if(this.state.isLoading) {
                    this.setState({
                        isLoading: generic.isLoading
                    })
                }
                if(_.has(generic, "dialogOpen") && this.state.dialogOpen !== generic.dialogOpen) {
                    this.setState({
                        dialogOpen: generic.dialogOpen
                    })
                }
            }
        )
    }

    calcDays = () => {

        var {
            startDate, endDate, daysArray, dateArray
        } = this.state

        var days = moment.duration(moment(moment(endDate).hour(23)).diff(moment(moment(startDate).hour(1)))).asDays();
 
        var i = 0

        daysArray = []
        dateArray = []

        while (i < Math.ceil(days)) {
            daysArray.push(moment(startDate).add(i, 'days').format("dd"))
            dateArray.push(moment(startDate).add(i, 'days').toDate())
            i++;
        }

        this.setState({
            daysArray: daysArray,
            dateArray: dateArray
        })

        var d = endDate.toDate()
        var monat = d.getMonth() + 1
        var jahr = d.getFullYear()

        this.props.mitarbeiter_doLoad({
            _von: startDate.format("YYYY-MM-DD"),
            _bis: endDate.format("YYYY-MM-DD"),
            monat: monat,
            jahr: jahr
        })

        if(this.state.currentMitarbeiter) {
            this.props.dienste_doLoad(this.state.currentMitarbeiter.id, {von: moment(this.state.startDate).format("YYYY-MM-DD"), bis: moment(this.state.endDate).format("YYYY-MM-DD")})
        }

    }

    month_change = (direction) => {
        var tmpMonth = _.clone(this.state.tmpMonth)
        if(!direction) {
            this.state.tmpMonth = tmpMonth.subtract(1, 'months')
        } else {
            this.state.tmpMonth = tmpMonth.add(1, 'months')
        }
        this.state.startDate = moment(this.state.tmpMonth).startOf('month')
        this.state.endDate = moment(this.state.tmpMonth).endOf('month')
        this.calcDays()
    }

    month_now = () => {
        this.state.startDate = moment().startOf('month')
        this.state.endDate = moment().endOf('month')
        this.state.tmpMonth = moment()
        this.calcDays()
    }

    selectUser = (id) => {
        this.props.dienste_doLoad(id, {von: moment(this.state.startDate).format("YYYY-MM-DD"), bis: moment(this.state.endDate).format("YYYY-MM-DD")})

        var currentMitarbeiter = {}
        this.props.mitarbeiter.data.forEach((mitarbeiter) => {
            if(mitarbeiter.id === id) {
                currentMitarbeiter = mitarbeiter
            }
        })
        this.setState({
            selectedUser: id,
            currentMitarbeiter: currentMitarbeiter
        })
    }

    unselectUser = () => {
        this.setState({
            selectedUser: undefined,
            currentMitarbeiter: undefined
        })
    }

    render() {

        var { classes, mitarbeiter, dienst } = this.props
        var { newEntry, isLoading, dialogOpen, newEntry, daysArray, dateArray, selectedUser, currentMitarbeiter } = this.state

        var {
            startDate, endDate, showLoader
        } = this.state


        var showLoader = false
        if(mitarbeiter.isLoading || dienst.isLoading) {
            showLoader = true
        }
        
        return (
			<div className="monatsuebersicht">
				<div className="header">
					<Paper style={{ position: "relative" }}>
						<Grid container spacing={8} className="leitstand-datum">
							<Grid item xs={3}>
								<Button onClick={() => this.month_change(false)}>- Monat</Button>
								<Button onClick={this.month_now}>{moment().format("MMMM")}</Button>
								<Button onClick={() => this.month_change(true)}>Monat +</Button>
							</Grid>
							<Grid item xs={4}>
								<h3>
									{moment(startDate).isValid() && moment(startDate).format("MMMM YYYY")}
									{currentMitarbeiter && ": " + currentMitarbeiter.familienname + " " + currentMitarbeiter.name}
									{selectedUser && <button className="unselectUser" onClick={() => this.unselectUser()}>(Auswahl aufheben)</button>}
								</h3>
							</Grid>
							<Grid item xs={5} className="text-right">
								<ButtonGroup
									groupName={
										<div className="alignCenter">
											<PrintIcon className="marginRight" /> {selectedUser ? "Monatsübersicht" : "Alle Monatsübersichten"}
										</div>
									}
									links={[
										{ icon: <PrintIcon />, label: <span>SOLL</span>, onClick: () => this.props.print({ von: moment(startDate).format("YYYY-MM-DD"), bis: moment(endDate).format("YYYY-MM-DD"), mitarbeiter: selectedUser }) },
										{ icon: <PdfIcon />, label: <span>SOLL</span>, onClick: () => this.props.print_download({ von: moment(startDate).format("YYYY-MM-DD"), bis: moment(endDate).format("YYYY-MM-DD"), mitarbeiter: selectedUser }) },
										{ divider: true },
										{ icon: <PrintIcon />, label: <span>IST</span>, onClick: () => this.props.print({ von: moment(startDate).format("YYYY-MM-DD"), bis: moment(endDate).format("YYYY-MM-DD"), ist: true, mitarbeiter: selectedUser }) },
										{ icon: <PdfIcon />, label: <span>IST</span>, onClick: () => this.props.print_download({ von: moment(startDate).format("YYYY-MM-DD"), bis: moment(endDate).format("YYYY-MM-DD"), ist: true, mitarbeiter: selectedUser }) },
									]}
								/>

								<ButtonGroup
									groupName={
										<div className="alignCenter">
											<PrintIcon className="marginRight" /> {selectedUser ? "Umlaufpläne" : "Alle Umlaufpläne"}
										</div>
									}
									links={[
										{ icon: <PrintIcon />, label: "Drucken", onClick: () => this.props.tagesblatt_print({ von: moment(startDate).format("YYYY-MM-DD"), bis: moment(endDate).format("YYYY-MM-DD"), mitarbeiter: selectedUser }) },
										{ icon: <PrintIcon />, label: "Drucken Small", onClick: () => this.props.tagesblatt_print({ von: moment(startDate).format("YYYY-MM-DD"), bis: moment(endDate).format("YYYY-MM-DD"), mitarbeiter: selectedUser, small: true }) },
										{ icon: <PdfIcon />, label: "Download", onClick: () => this.props.tagesblatt_print_download({ von: moment(startDate).format("YYYY-MM-DD"), bis: moment(endDate).format("YYYY-MM-DD"), mitarbeiter: selectedUser }) },
										{ icon: <PdfIcon />, label: "Download Small", onClick: () => this.props.tagesblatt_print_download({ von: moment(startDate).format("YYYY-MM-DD"), bis: moment(endDate).format("YYYY-MM-DD"), mitarbeiter: selectedUser, small: true }) },
									]}
								/>
							</Grid>
						</Grid>
						{showLoader && <LinearProgress style={{ width: "100%", position: "absolute", zIndex: 9999 }} />}
					</Paper>
				</div>

				<div style={{ display: "flex", flexDirection: "row" }}>
					<MitarbeiterTable selectUser={this.selectUser} mitarbeiter={mitarbeiter.data} />
					{currentMitarbeiter ? <StundenTable dienst={dienst.data} currentMitarbeiter={currentMitarbeiter} mitarbeiter={mitarbeiter.data} daysArray={daysArray} dateArray={dateArray} saveDienst={this.props.saveDienst} /> : <div style={{ padding: 20 }}>Bitte Mitarbeiter auswählen</div>}
				</div>
			</div>
		);
    }

}

/*

<Button onClick={}><PrintIcon  className="marginRight" /> Monatsübersicht</Button>

*/

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
    dienst: state.dienst,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    mitarbeiter_doLoad: (filter) => dispatch(doLoad(ENDPOINT, "api/generic/"+ENDPOINT+"/list", {sort: "asc", ...filter})),
    dienste_doLoad: (id, filter) => dispatch(doLoad("dienst", "api/generic/dienst/single/" + id, filter)),
    doSearch: (filter) => dispatch(doLoad(ENDPOINT, "api/generic/"+ENDPOINT+"/list", filter)),
    doDelete: (id) => dispatch(doDelete(ENDPOINT, "api/generic/"+ENDPOINT+"/"+id, id)),

    saveDienst: (id, data) => dispatch(doPut("dienstSingle", "api/generic/dienst/"+id+"?type=zeit", data)),

    print: (filter) => dispatch(apiUrlOpen("api/pdf/dienstplan/dienstplan.pdf", filter, true)),
    print_download: (filter) => dispatch(apiUrlOpen("api/pdf/dienstplan/dienstplan.pdf", filter, false)),
    tagesblatt_print: (filter) => dispatch(apiUrlOpen("api/pdf/umlaufplan/umlaufplan.pdf", filter, true)),
    tagesblatt_print_download: (filter) => dispatch(apiUrlOpen("api/pdf/umlaufplan/umlaufplan.pdf", filter, false)),

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ListObject));



// WEBPACK FOOTER //
// ./src/Routes/Monatsuebersicht/index.js